<template>
  <section id="skills">
    <h2>مهارت های اصلی</h2>
    <div id="main-skills-chart" >
      <div class="row" :key="index" v-for="(item,index) in info['main']">
        <span class="skill-title"> {{ item.name }} </span>
        <span class="skill-chart-parent">
          <span :style="{ 'width' : item.level + '%'}" class="skill-chart-child"> </span>
        </span> 
        <!-- <span class="skill-description">{{ item.level }}</span> -->
      </div>
      
      
    </div>

    <hr />
    <h2>مهارت های فرعی</h2>
    <div id="sub-skills-chart">
      <div class="row" :key="index" v-for="(item,index) in info['other']">
        <span class="skill-title"> {{ item.name }} </span>
        <span class="skill-chart-parent">
          <span :style="{ 'width' : item.level + '%'}" class="skill-chart-child"> </span>
        </span>
        <!-- <span class="skill-description">کمتر از 1 سال</span> -->
      </div>
      
    </div>

    <hr />
    <h2>زبان</h2>
    <div id="lang-skills-chart">
      <div class="row" :key="index" v-for="(item,index) in info['lang']">
        <span class="skill-title"> {{ item.name }} </span>
        <span class="skill-chart-parent">
          <span :style="{ 'width' : item.level + '%'}" class="skill-chart-child"> </span>
        </span>
        <!-- <span class="skill-description">زبان مادری</span> -->
      </div>
      
    </div>
  </section>
</template>

<script>
import axios from "axios"
export default {
  beforeCreate: function () {
    document.body.className = "skills";
  },
  data() {
    return {
      info: {},
    };
  },
  mounted() {
    axios
      .post("https://mohammadrostamidevapi.iran.liara.run/api/v1/skills", {})
      .then((respose) => (this.info = respose.data))
      .then((error) => console.log(error));
    // console.log(this.info)
  },
};
</script>

<style></style>
